import { Link } from "react-router-dom";
import { LegalPage } from "../components/LegalPage";
import { site } from "../config/site";

export default function MentionsLegales() {
  return (
    <LegalPage
      title="Mentions légales | TN FOOD"
      description="Mentions légales du site tnfood.food — TN FOOD, SAS au capital de 1 000 €, RCS Troyes, Sainte-Savine."
      path="/mentions-legales"
      updated="janvier 2026"
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site tnfood.food est édité par TN FOOD, Société par Actions Simplifiée (SAS) au capital de {site.capital},
        dont le siège social est situé {site.address.full}.<br />
        {site.rcs} — SIREN {site.siren} — SIRET (siège) {site.siret} — Code APE/NAF : {site.ape}.<br />
        TVA intracommunautaire : {site.tvaIntra}.<br />
        Email : <a href={`mailto:${site.email}`}>{site.email}</a> — Téléphone : <a href={site.phoneHref}>{site.phone}</a>.
      </p>

      <h2>2. Directeur de la publication</h2>
      <p>Monsieur NEJI Ali, en qualité de Président de la société TN FOOD.</p>

      <h2>3. Hébergeur</h2>
      <p>
        {site.host.name} — {site.host.address} — Téléphone : {site.host.phone} — Site : {site.host.site}.
      </p>

      <h2>4. Propriété intellectuelle</h2>
      <p>
        L'ensemble des contenus du site (textes, images, logo, charte graphique, structure) est protégé par le droit
        d'auteur et demeure la propriété exclusive de TN FOOD ou de ses ayants droit. Toute reproduction,
        représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.
      </p>

      <h2>5. Données personnelles et cookies</h2>
      <p>
        Les traitements de données personnelles réalisés via ce site sont décrits dans notre{" "}
        <Link to="/politique-de-confidentialite">politique de confidentialité</Link>.
      </p>

      <h2>6. Allergènes</h2>
      <p>
        Conformément au règlement UE n° 1169/2011 (INCO), la liste des 14 allergènes majeurs est disponible sur demande
        auprès de notre personnel et affichée en salle.
      </p>

      <h2>7. Droit applicable et juridiction compétente</h2>
      <p>
        Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de solution
        amiable, les tribunaux de Troyes seront compétents.
      </p>
    </LegalPage>
  );
}
